var exports = {
  "PT": "Markup.module__markup___eU1zZE",
  "z3": "Markup.module__bio___eU1zZE",
  "Z_": "Markup.module__mutedSpoilerContext___eU1zZE",
  "nf": "Markup.module__link___eU1zZE",
  "mG": "Markup.module__inline___eU1zZE",
  "tZ": "Markup.module__inlineFormat___eU1zZE",
  "Hy": "Markup.module__codeContainer___eU1zZE",
  "h": "Markup.module__blockquoteContainer___eU1zZE",
  "xE": "Markup.module__alert___eU1zZE",
  "CZ": "Markup.module__tableContainer___eU1zZE",
  "js": "Markup.module__latexCodeBlock___eU1zZE",
  "lB": "Markup.module__codeActions___eU1zZE",
  "vo": "Markup.module__codeActionsVisible___eU1zZE",
  "r": "Markup.module__blockquoteDivider___eU1zZE",
  "rs": "Markup.module__blockquoteContent___eU1zZE",
  "em": "Markup.module__blockquoteEmptyContent___eU1zZE",
  "tp": "Markup.module__table___eU1zZE",
  "qd": "Markup.module__tableHeader___eU1zZE",
  "xR": "Markup.module__tableCell___eU1zZE",
  "Vl": "Markup.module__alignLeft___eU1zZE",
  "Hu": "Markup.module__alignCenter___eU1zZE",
  "Wk": "Markup.module__alignRight___eU1zZE",
  "Qd": "Markup.module__alertIcon___eU1zZE",
  "Ro": "Markup.module__alertTitle___eU1zZE",
  "S9": "Markup.module__alertContent___eU1zZE",
  "FU": "Markup.module__alertNote___eU1zZE",
  "ap": "Markup.module__alertTip___eU1zZE",
  "nL": "Markup.module__alertImportant___eU1zZE",
  "vc": "Markup.module__alertWarning___eU1zZE",
  "SN": "Markup.module__alertCaution___eU1zZE",
  "lE": "Markup.module__mention___eU1zZE",
  "bG": "Markup.module__interactive___eU1zZE",
  "vE": "Markup.module__timestamp___eU1zZE",
  "CU": "Markup.module__spoilerWrapper___eU1zZE",
  "N5": "Markup.module__blockSpoilerWrapper___eU1zZE",
  "p6": "Markup.module__spoiler___eU1zZE",
  "mC": "Markup.module__blockSpoiler___eU1zZE",
  "ur": "Markup.module__spoilerContent___eU1zZE",
  "yI": "Markup.module__latexContent___eU1zZE",
  "Y4": "Markup.module__hljs___eU1zZE",
  "HQ": "Markup.module__ansiCode___eU1zZE",
  "bi": "Markup.module__ansi-code-blink___eU1zZE",
  "So": "Markup.module__error___eU1zZE",
  "Dz": "Markup.module__roleMention___eU1zZE",
};

module.exports = exports;
